export default "__VITE_ASSET__d6ac920d__"